<template>
	<div class="page">
		<div title="talentTemplate" is='headered'></div>
		<!--阶段项目标题-->
		<div class="public_title">
			<div>少年阶段——</div>
			<div>小小项目师、少年发明家</div>
			<div class="public_titleImg">
				<img src="../../assets/小鹅通.png"/>
				<div>青少年行为管理与思维创新</div>
			</div>
		</div>
		<div style="margin-bottom: 30px;" class="textInfo">北京安达思创有限公司致力于开发“小小项目师”“少年发明家”系列课程，并享有著作权，与CYC的PBL式项目制教学结合。中国青年项目管理委员会CYC 隶属于国际项目管理协会IPMA(www.ipma.world) CYC 引进风靡欧美日等“项目制教学PBL”开发出国内独家针对青少年自我管理的 “小小项目师”课程。主题从时间计划、费用预算、团队组织、归类整理、风险防范等多方面培养。通过时间、归纳、金钱观、风险、团队等几个方面的“法宝攻略” 学会施展魔法般的执行力。从学习和生活的自我管理开始“情商+智商+财商”！
		</div>
		<div class="textInfo">“小小项目师”体系来源于二战后发展的国际项目管理，国际项目管理协会IPMA发布IPMP四级资质证书、国际卓越管理大奖、这些为风靡全球的“项目制教学PBL”注入最前沿、最引领的知识体系。这就是中国“小小项目师”教学的强大学术后盾和国际平台。目前中国青年项目管理委员会CYC的PBL项目制教学结合最新知识体系，内容丰富并实效，已经处于 IPMA青少年教育战略的引领地位。
		</div>
		<div class="evaluate_title">国际项目管理协会IPMA主席对于“小小项目师”体系的赞誉</div>
		<div class="evaluate_row">
			<div class="evaluate_item">
				<img src="../../assets/stageImg/stage1_16.png" />
				<div>
					<div>马丁内斯·阿尔梅拉</div>
					<div>Jesús Martínez Almela</div>
					<div>国际项目管理协会IPMA——现任主席</div>
					<div class="personName">
						<img src="../../assets/stageImg/person1_img.png" />
					</div>
				</div>
			</div>
			<div class="evaluate_item">
				<img src="../../assets/stageImg/stage1_18.png" />
				<div>
					<div>维克·沃雷勒</div>
					<div>Veikko Valila</div>
					<div>国际项目管理协会IPMA——前任主席</div>
					<div class="personName">
						<img src="../../assets/stageImg/person2_img.png" />
					</div>
				</div>
			</div>
		</div>
		<!--<img class="f_img" src="../../assets/stageImg/stage1_1.png" />-->
		<div class="youngRow">
			<div class="youngItem">
				<div class="title">自我管理</div>
				<div class="text">做时间的主人</div>
				<div class="text">整理和归纳</div>
				<div class="text">正确的金钱观</div>
				<div class="text">远离危险风险防范</div>
			</div>
			<div class="youngItem">
				<div class="title">团队管理</div>
				<div class="text">责任矩阵 </div>
				<div class="text">问责制度</div>
				<div class="text">积极沟通</div>
				<div class="text">组建团队和分工</div>
			</div>
			<div class="youngItem">
				<div class="title">创新管理</div>
				<div class="text">前苏联国宝级智库</div>
				<div class="text">萃智TRIZ发明创造40原理</div>
				<div class="text">发明创造有办法</div>
				<div class="text">让普通人成为发明家</div>
			</div>
		</div>
		
		
		
		<div class="addNew_dfRow">
			<div class="addNew_dfs">
				<div class="addNew_title">创新能力：</div>
				<div class="addNew_text">创新思维与创新技能，实现发明专利</div>
			</div>
			<div class="addNew_dfs">
				<div class="addNew_title">团队合作能力：</div>
				<div class="addNew_text">集体分工配合完成一件事情</div>
			</div>
			<div class="addNew_dfs">
				<div class="addNew_title">质量控制能力：</div>
				<div class="addNew_text">保质保量按时完成任务，自我管理</div>
			</div>
			<div class="addNew_dfs">
				<div class="addNew_title">风险控制能力：</div>
				<div class="addNew_text">保护自己、远离危险、识别未知的风险</div>
			</div>
			<div class="addNew_dfs">
				<div class="addNew_title">时间规划能力：</div>
				<div class="addNew_text">从计划好每件事的时间，到规划学业和人生</div>
			</div>
			<div class="addNew_dfs">
				<div class="addNew_title">金钱观：</div>
				<div class="addNew_text">懂得金钱的概念、财商培养、树立正确的金钱观</div>
			</div>
			<img class="addNew_dfRow_img" src="../../assets/stageImg/juven_image.png"/>
		</div>
		<div class="sec_imgList">
			<div>
				<img src="../../assets/stageImg/stage1_2.png" />
				<img src="../../assets/stageImg/stage1_6.png" />
			</div>
			<div>
				<img style="height: 446px;" src="https://static.feijingbang.com/upload/5a62863a43bf44d0a560fbfc24c4e9f0"/>
				<!--<img src="../../assets/stageImg/stage1_3.png" />
				<img src="../../assets/stageImg/stage1_7.png" />-->
			</div>
			<div>
				<img style="height: 446px;" src="https://static.feijingbang.com/upload/b9a338f57e464ac79defc097ed7cac4b"/>
				<!--<img src="../../assets/stageImg/stage1_4.png" />
				<img src="../../assets/stageImg/stage1_8.png" />-->
			</div>
			<div>
				<img src="../../assets/stageImg/stage1_5.png" />
				<img src="../../assets/stageImg/stage1_9.png" />
			</div>	
		</div>
		<div class="sec_imgList2">
				<img src="../../assets/stageImg/stage1_3.png" />
				<img src="../../assets/stageImg/stage1_7.png" />
				<img src="../../assets/stageImg/stage1_4.png" />
				<img src="../../assets/stageImg/stage1_8.png" />
		</div>
		
		<div style="margin-bottom: 60px;" class="evaluate_title">教育支教公益帮扶</div>
		<div class="thre_box_row1">
			<div>
				<img src="../../assets/stageImg/stage1_10.png" />
				<img src="../../assets/stageImg/stage1_11.png" />
			</div>
			<img src="../../assets/stageImg/stage1_12.png" />
		</div>
		<div class="thre_box_row2">
			<img src="../../assets/stageImg/stage1_13.png" />
			<img src="../../assets/stageImg/stage1_14.png" />
			<img src="../../assets/stageImg/stage1_15.png" />
		</div>
		<!--公共底部-->
		<div is='footed'></div>

	</div>
</template>

<script>
	import headered from '@/components/header';
	import footed from '@/components/foot';
	export default {
		name: 'index',
		components: {
			headered,
			footed
		},
		data() {
			return {}
		}
	}
</script>

<style scoped="scoped">
	.public_title {
		width: 1200px;
		margin: 0 auto;
		margin-top: 90px;
		margin-bottom: 60px;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
	}
	
	.public_title div {
		line-height: 48px;
		color: #1F2329;
		font-size: 36px;
		text-align: left;
		font-weight: bold;
	}
	
	.public_title>div:nth-child(2) {
		color: #0080FF;
		margin-right: 50px;
	}
	.public_title .public_titleImg{
		width: 200px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	.public_title .public_titleImg img{
		width: 100px;
		height: 100px;
	}
	.public_title .public_titleImg div{
		font-size: 14px;
		line-height: 20px;
		width: 200px;
		text-align: center;
		color: #333;
	}
	.textInfo {
		width: 1200px;
		margin: 0 auto;
		line-height: 30px;
		font-size: 18px;
		color: #51565D;
		text-align: left;
		margin-bottom: 60px;
		text-indent: 2em;
	}
	
	.f_img {
		width: 996px;
		height: 273px;
		margin: 0 auto;
		margin-bottom: 80px;
	}
	
	.sec_imgList {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: flex-start;
		flex-wrap: wrap;
	}
	
	.sec_imgList>div {
		width: 282px;
		margin-right: 24px;
		margin-bottom: 24px;
	}
	.sec_imgList>div img{
		width: 282px;
		height: 211px;
		margin-bottom: 24px;
	}
	.sec_imgList div:nth-child(4n) {
		margin-right: 0px;
	}
	.sec_imgList2{
		width: 1200px;
		margin: 0 auto;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 36px;
	}
	.sec_imgList2 img{
		width: 282px;
		margin-bottom: 24px;
	}
	
	
	.thre_box_row1 {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
		margin-bottom: 24px;
	}
	
	.thre_box_row1>div {
		margin-right: 24px;
	}
	
	.thre_box_row1>div img:nth-child(1) {
		width: 792px;
		height: 482px;
		margin-bottom: 24px;
	}
	
	.thre_box_row1>div img:nth-child(2) {
		width: 792px;
		height: 327px;
	}
	
	.thre_box_row1>img {
		width: 384px;
		height: 833px;
	}
	
	.thre_box_row2 {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 120px;
	}
	
	.thre_box_row2 img {
		width: 384px;
		height: 585px;
	}
	
	.evaluate_title {
		width: 1200px;
		margin: 0 auto;
		font-weight: bold;
		line-height: 48px;
		font-size: 36px;
		text-align: left;
		color: #1F2329;
		margin-bottom: 60px;
	}
	
	.evaluate_row {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: flex-start;
	}
	
	.evaluate_item {
		margin: 0 auto;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: flex-start;
		margin-bottom: 60px;
	}
	
	.evaluate_item>img {
		width: 100px;
		height: 100px;
		margin-right: 24px;
	}
	
	.evaluate_item>div div:nth-child(1) {
		line-height: 32px;
		font-size: 24px;
		margin-bottom: 10px;
		text-align: left;
		color: #1F2329;
		font-weight: bold;
	}
	
	.evaluate_item>div div:nth-child(2) {
		line-height: 32px;
		font-size: 24px;
		margin-bottom: 10px;
		text-align: left;
		color: #1F2329;
		font-weight: bold;
	}
	
	.evaluate_item>div div:nth-child(3) {
		line-height: 22px;
		font-size: 18px;
		margin-bottom: 10px;
		text-align: left;
		color: #51565D;
		margin-bottom: 30px;
	}
	
	.evaluate_item .personName {
		width: 300px;
		height: 294px;
		background-color: rgb(199, 225, 250);
		padding: 30px 50px;
		border-radius: 0px 30px 30px 30px;
	}
	
	.evaluate_item .personName img {
		width: 200px;
		height: 234px;
	}
	.addNew_dfRow{
		width: 1200px;
		position: relative;
		margin: 0 auto;
		margin-bottom: 80px;
	}
	.addNew_dfRow .addNew_dfRow_img{
		position: absolute;
		right: 0px;
		top: 0px;
		width: 300px;
		height: 200px;
	}
	
	.addNew_dfs {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
		padding: 20px;
		border-bottom: 1px solid #eee;
	}
	.addNew_dfRow .addNew_dfs:nth-child(2){
		padding-left: 130px;
	}
	.addNew_dfRow .addNew_dfs:nth-child(3){
		padding-left: 280px;
	}
	.addNew_dfRow .addNew_dfs:nth-child(4){
		padding-left: 430px;
	}
	.addNew_dfRow .addNew_dfs:nth-child(5){
		padding-left: 580px;
	}
	.addNew_dfRow .addNew_dfs:nth-child(6){
		justify-content: flex-end;
	}
	
	
	.addNew_title {
		line-height: 24px;
		font-size: 20px;
		color: #0080FF;
		font-weight: 560;
	}
	
	.addNew_text {
		line-height: 24px;
		font-size: 18px;
		color: #51565D;
	}
	
	
	.youngRow{
		width: 1200px;
		margin: 0 auto;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 40px;
	}
	.youngItem{
		width: 282px;
		min-height: 198px;
		padding: 40px 0px;
		background-color: rgb(199, 225, 250);
		text-align: left;
	}
	.youngItem>.title{
		line-height: 24px;
		font-size: 24px;
		color: #1F2329;
		margin-bottom: 20px;
		font-weight: bold;
		text-align: center;
	}
	.youngItem>.text{
		line-height: 24px;
		font-size: 18px;
		color: #51565D;
		text-align: center;
		margin-bottom: 10px;
	}
	
	
</style>


// WEBPACK FOOTER //
// src/views/phaseList/juvenileStage.vue